var DialogUtils = (function($) { // The parameter imports the JQuery namespace "$".

    var my = {};

    my.setupDialog = function(dialogSelector) {
        // Check if jQuery UI dialog is available
        if (!$.fn.dialog) {
            console.error('jQuery UI dialog is not loaded. Cannot setup dialog.');
            return dialogSelector; // Return the original selector as fallback
        }
        
        var maxWidth = 620;
        var setWidth = $(window).width() * 0.95;
        if (setWidth > maxWidth) {
            setWidth = maxWidth;
        }
        return dialogSelector.dialog({
            autoOpen: false,
            width: setWidth,
            left: 20,
            closeText: '',
            dialogClass: '',
            modal: true,
            resizable: false,
            draggable: false,
            open: function() {
                DialogUtils.closeOnCancel($(this));
                DialogUtils.closeOnEsc($(this));
                DialogUtils.closeOnClickOutsideDialog($(this));

                // Avoid first clickable element getting focus
                clearFocus($(this));
            }
        });
    };

    my.closeOnCancel = function(dialogSelector) {
        var $close = dialogSelector.find('.close');

        $close.off('click.dialogUtils').on('click.dialogUtils', function() {
            dialogSelector.dialog('close');
        });

        $close.off('keypress.dialogUtils').on('keypress.dialogUtils', function(e) {
          if(e.which == 13) { // Enter key
            dialogSelector.dialog('close');
          }
        });
    };

    my.closeOnEsc = function(dialogSelector) {
        dialogSelector.dialog().off('keydown.dialogUtils').on('keydown.dialogUtils', function(event) {
            if (event.keyCode === $.ui.keyCode.ESCAPE) {
                $(this).dialog('close');
            }
            event.stopPropagation();
        });
    };

    my.closeOnClickOutsideDialog = function(dialogSelector) {
        $('.ui-widget-overlay').off('click.dialogUtils').on('click.dialogUtils', function () {
            dialogSelector.dialog('close');
        });
    };

    my.centerOpenDialog = function() {
      $(".ui-dialog-content").dialog("option", "position", {
        my: "center",
        at: "center",
        of: window
      });
    }

    function clearFocus(dialogSelector) {
      dialogSelector.parents('.ui-dialog').attr('tabindex', -1)[0].focus();
    }

    return my;

}(jQuery));

// Make DialogUtils globally available for legacy code
window.DialogUtils = DialogUtils;
